import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
  btn: {
    backgroundColor: theme.palette.secondary.main,
    fontFamily: "Montserrat",
    // color: "white",
    fontWeight: 600,
    fontSize: "1.2rem",
    padding: theme.spacing(2),
    borderTopRightRadius: 20,
    borderBottomLeftRadius: 20,
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
}));

const FancyButton = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Button className={classes.btn}>{props.children}</Button>
    </div>
  );
};
export default FancyButton;
